import I18n from './index'

// Função para mudar o idioma manualmente
export const changeLanguage = (lang) => {
    I18n.locale = lang
    // Atualize a página ou re-renderize os componentes se necessário
}

// Função para obter o idioma atual
export const getCurrentLanguage = () => {
    return I18n.locale
}
